import React, { PropTypes } from 'react';
import male from '../../images/male.png';
import female from '../../images/female.png';
import infoIcon from '../../images/ic_alert_circle.png';
import { browserHistory } from 'react-router';
import './PatientGenderCard.scss';

const options = [
  { label: 'Male', value: 'm', img: male },
  { label: 'Female', value: 'f', img: female },
];

const staticText = {
  question: 'What is the patient gender?',
  info: 'Fasting is not required for an ECG — you may have a light meal. Avoid caffeine and alcohol for 6–8 hours, and stay hydrated with water.',
  note: 'Note: Ask the customer to follow fasting instructions if our internal package includes any fasting-based tests.',
  proceedButtonText: 'Proceed',
};

const PatientGenderCard = ({ selectedGender, onGenderSelect, onClose }) => {
  const onProceed = () => {
    if (selectedGender) {
      onGenderSelect(selectedGender);      // Set the gender
      onClose();                           // Close the popup
      browserHistory.push('/diagnostics/review-order');
    }
  };
  const handleChange = event => {
    const gender = event.target.value;
    onGenderSelect(gender);
  };
  return (
    <div className="container">
      <div className="card">
        <button
          className="close-button"
          onClick={onClose}
        >
        &times;
      </button>
        <div className="gender-selection-card">
          <div className="question-text">{staticText.question}</div>
          <div className="options">
            {options.map(({ label, value, img }) => {
              const inputId = `gender-${value}`;
              return (
                <div
                  className="genders"
                  key={value}
                >
                  <label htmlFor={inputId} className="gender-label">
                    <img src={img} alt={label} width="11" height="24" />
                    {label}
                  </label>
                  <input
                    type="radio"
                    id={inputId}
                    name="gender"
                    value={value}
                    checked={selectedGender === value}
                    onChange={handleChange}
                    className="gender-radio"
                  />
                </div>
              );
            })}
          </div>
        </div>
        <div className="note-section">
          <img
            src={infoIcon}
            alt="info_icon"
            className="info-icon"
          />
          <div className="note-text">
            <div >{staticText.note}</div>
            <div >{staticText.info}</div>
          </div>
        </div>
        <div className="proceed-button-wrapper">
          <button
            className={`proceed-button ${selectedGender ? 'enabled' : 'disabled'}`}
            disabled={!selectedGender}
            onClick={onProceed}
          >
            {staticText.proceedButtonText}
          </button>
        </div>
      </div>
    </div>
  );
};

PatientGenderCard.propTypes = {
  selectedGender: PropTypes.string.isRequired,
  onGenderSelect: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onProceed: PropTypes.func.isRequired,
};

export default PatientGenderCard;
